import {
    ChallengeNameType,
    CognitoIdentityProviderClient,
    CognitoIdentityProviderClientConfig,
    RespondToAuthChallengeCommand,
} from '@aws-sdk/client-cognito-identity-provider'
import getConfig from 'next/config'

async function changeTemporaryPassword(data: Record<string, string>, Session: string | undefined) {
    const { COGNITO_CLIENT_ID: client_id, COGNITO_REGION: region } =
        getConfig().publicRuntimeConfig
    const config: CognitoIdentityProviderClientConfig = {
        region,
    }
    const ChallengeResponses = {
        NEW_PASSWORD: data.new_password,
        USERNAME: data.email
    }
    const client = new CognitoIdentityProviderClient(config)
    const command = new RespondToAuthChallengeCommand({
        ClientId: client_id,
        ChallengeName: ChallengeNameType.NEW_PASSWORD_REQUIRED,
        ClientMetadata: data,
        ChallengeResponses,
        Session
    })
    return await client.send(command)
}

export default changeTemporaryPassword
